export class ProductCodePrefixApiModel {
    prefix: string;
    drinkType: string;
    drinkColour: string;
    countryTerritory: string;
    region: string;
    notes: string;
}